import styled from 'styled-components';
import { customMedia, isThemeColor, hexa } from 'styles/utils';
import { fadeIn } from 'styles/animation';

const zIndex = 99999;
const positionFixedFullScreen = `
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

export const ModalBackground = styled.div`
  z-index: ${zIndex};
  ${positionFixedFullScreen}
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${props =>
    isThemeColor(props.backgroundThemeColor[0])
      ? hexa(
          props.theme.color[props.backgroundThemeColor[0]],
          props.backgroundThemeColor[1],
        )
      : hexa(props.theme.color.wfBlack, 0.8)};
  transition: opacity 1s ease-in-out;

  ${customMedia.greaterThan('medium')`
    display: ${props => (props.mobile ? 'none' : 'flex')};
  `}
`;

export const MainWrapper = styled.nav`
  z-index: ${zIndex + 1};
  pointer-events: none;
  ${positionFixedFullScreen}
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  animation: ${fadeIn} 1s;

  ${customMedia.greaterThan('medium')`
    display: ${props => (props.mobile ? 'none' : 'flex')};
  `}
`;

export const ChildrenWrapper = styled.div`
  pointer-events: auto;
`;

export const FooterWrapper = styled.div`
  z-index: ${zIndex + 2};
  position: fixed;
  //right: 0;
  //left: 0;
  //bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  bottom: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const mobileCircleSize = '5rem';
const desktopCircleSize = '2rem';
const circleSize = size => `
  width: ${size};
  min-width: ${size};
  max-width: ${size};
  height: ${size};
  min-height: ${size};
  max-height: ${size};
  border-radius: ${size};
`;
export const CloseCircleBlock = styled.div`
  pointer-events: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  ${circleSize(mobileCircleSize)}
  // margin: ${props => props.theme.spacing.large};
  background-color: ${props => props.theme.color.wfWhite};

  ${customMedia.greaterThan('medium')`
    ${circleSize(desktopCircleSize)}
  `}
`;
